import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the WastePickupFormManifestScreen state domain
 */

const selectWastePickupFormManifestScreenDomain = state =>
  state.wastePickupFormManifestScreen || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by WastePickupFormManifestScreen
 */

const makeSelectWastePickupFormManifestScreen = () =>
  createSelector(
    selectWastePickupFormManifestScreenDomain,
    substate => substate,
  );

export default makeSelectWastePickupFormManifestScreen;
export { selectWastePickupFormManifestScreenDomain };
